import { CloseButton, ETitle, Modal } from '../../../../components/ui'
import { useState } from 'react'
import { Button } from '../../../../components/ui/legacy'
import useInfinitySearchAccount from '../../../account-management/account-list/hooks/useInfinitySearchAccount'
import { addAdminService } from '../../../../service/AddAminService'
function SearchAccount({ onSelectValue }) {
  const [keyword, setKeyword] = useState('')
  
  const { ref, data, isLoading } = useInfinitySearchAccount({
    keyword,
    pageSize: 8,
  })
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    className: '',
  })

  const handleInputChange = (e) =>  setKeyword(e.target.value)

  const handleSuggestionClick = (uuid) => {
    const selectedUser = data?.pages
      ?.flatMap((page) => page.users)
      .find((item) => item.uuid === uuid)

    if (selectedUser) {
      setFormData({
        name: selectedUser.name,
        email: selectedUser.schoolEmail,
        className: selectedUser.className,
      })
      onSelectValue(uuid)
      setKeyword('')
    }
  }

  return (
    <div>
      <div className="mt-4">
        <label htmlFor="admin-search" className="mb-2 block font-semibold">
          Tìm kiếm tài khoản:
        </label>
        <input
          type="text"
          value={keyword}
          onChange={handleInputChange}
          placeholder="Nhập tên hoặc email"
          className="w-full rounded border p-2"
        />

        {isLoading && <p>Đang tải...</p>}

        {keyword !== '' && (
          <ul className="mt-2 max-h-[15vh] overflow-y-auto rounded border border-gray-300">
            {data?.pages?.map((page, pageIndex) =>
              page.users.map((user, userIndex) => {
                const isPrefetchRow = userIndex === page.users.length - 2
                return (
                  <li
                    key={user.uuid}
                    ref={isPrefetchRow ? ref : null}
                    className="cursor-pointer p-2 hover:bg-gray-100"
                    onClick={() => handleSuggestionClick(user.uuid)}
                  >
                    {user.id} - {user.name} - {user.schoolEmail}
                  </li>
                )
              })
            )}
          </ul>
        )}

        {keyword !== '' && !data?.pages?.[0]?.users?.length && (
          <div className="mt-2 rounded border border-gray-300 p-2 text-center">
            Không có kết quả
          </div>
        )}
      </div>

      {['name', 'email', 'className'].map((field) => (
        <div className="mt-4 flex items-center" key={field}>
          <label
            htmlFor={field}
            className="mb-2 block whitespace-nowrap p-2 font-semibold"
          >
            {field === 'name'
              ? 'Tên'
              : field === 'email'
                ? 'Email'
                : 'Chuyên ngành'}
            :
          </label>
          <input
            id={field}
            type="text"
            value={formData[field]}
            className="ml-auto w-9/12 cursor-not-allowed rounded border p-2"
            disabled
            readOnly
          />
        </div>
      ))}
    </div>
  )
}
export default function FormCreateAdminModal({ onClose }) {
  const [uuid, setUuid] = useState('')
  const [error, setError] = useState(null)

  const submitHandler = async () => {
    if (!uuid) {
      setError('UUID is required')
      return
    }
    setError(null)
    const formData = { uuid }
    await addAdminService.add(formData)
    window.location.reload()
  }

  return (
    <Modal
      onClose={onClose}
      className="w-[700px] rounded-md bg-white p-8 text-gray-accent"
    >
      <header className="relative w-full">
        <ETitle text={'THÊM QUẢN TRỊ VIÊN'} className={'text-center'} />
        <CloseButton
          className="absolute right-0 top-0"
          onClickHandler={onClose}
        />
      </header>
      <SearchAccount
        onSelectValue={(selectedUuid) => {
          setUuid(selectedUuid)
        }}
      />
      {error && <p className="mt-2 text-red-500">{error}</p>}
      <Button
        variant="primary"
        onClickHandler={submitHandler}
        disabled={!uuid}
        className="mx-auto mt-8"
      >
        Thêm
      </Button>
    </Modal>
  )
}
